<template>
  <div>
    <ul class="list-unstyled">
      <li :class="$style.item" @click="registerAutomaticPayment(card.id)">
        <a href="#" :class="$style.itemLink">
          <div :class="$style.itemPic">
            <!--<i class="fe fe-file-text"/>-->
            <img :src="card.payment_method.thumbnail" />
          </div>
          <div class="mr-2">
            <div>{{ card.payment_method.name }} terminada en {{ card.last_four_digits }}</div>
            <div class="text-muted">{{ card.issuer.name }}</div>
          </div>
          <!-- <p v-if="card.id === cardId">Registrada</p>-->
          <div :class="$style.itemAction">
            <span/>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const ACTIVATE_AUTOMATIC_PAYMENTS = gql`
mutation activateAutomaticPayment($concesionarioId: Int, $cardId: String){
  activateAutomaticPayment(concesionarioId: $concesionarioId, cardId: $cardId) {
    id
  }
}`
export default {
  props: ['card', 'cardId'],
  name: 'KitList5',
  methods: {
    registerAutomaticPayment(cardId) {
      this.$apollo.mutate({
        mutation: ACTIVATE_AUTOMATIC_PAYMENTS,
        context: headers(),
        variables: {
          concesionarioId: parseInt(this.$store.state.user.franchisee),
          cardId: cardId,
        },
      })
        .then(data => {
          // this.automaticPaymentModal = false
          console.log(data)
          this.makeToast(true, 'success', 'Registro de pago automático', 'Registro de pago automático realizado correctamente.')
        })
        .catch(error => {
          console.log(error)
        })
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 5000,
        appendToast: append,
        variant: variant,
      })
    },
  },
}
</script>
<style lang="scss" module>
  @import './style.module.scss';

</style>
